document.addEventListener('click', function (event) {
  const link = event.target.closest('a[href="#cookie-einstellungen"]');

  if (!link) return;

  event.preventDefault();

  if (
    window.privacyBanner &&
    typeof window.privacyBanner.showPreferences === 'function'
  ) {
    window.privacyBanner.showPreferences();
  }
});